import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import { postReq } from "../api";

export default function CreateSpocModal({
  open,
  onClose,
  companyId,
  onSuccess,
  isEdit = false,
  initialValues = null,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [open, initialValues, form]);

  const handleSubmit = async (values) => {
    const payload = isEdit
      ? {
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.phone,
          designation: values.designation,
          linkedinUrl: values.linkedinUrl,
          region: values.region,
          spocId: initialValues._id,
        }
      : {
          companyId,
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.phone,
          email: values.email,
          designation: values.designation,
          linkedinUrl: values.linkedinUrl,
          region: values.region,
          source: "manual",
        };

    if (isEdit) {
      await postReq(`/common/update_spoc`, payload);
    } else {
      await postReq("/common/create_spoc", payload);
    }

    form.resetFields();
    onClose();
    onSuccess && onSuccess();
  };

  return (
    <Modal
      open={open}
      title={isEdit ? "Edit SPOC" : "Add SPOC"}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="firstName"
          label="First Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="Enter first name" />
        </Form.Item>
        <Form.Item
          name="lastName"
          label="Last Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="Enter last name" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone"
          rules={[
            {
              pattern: /^[6-9]\d{9}$/,
              message: "Enter a valid 10-digit mobile number",
            },
          ]}
        >
          <Input placeholder="Enter mobile number" maxLength={10} />
        </Form.Item>
        {isEdit ? null : (
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Name is required" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="Enter email address" />
          </Form.Item>
        )}
        <Form.Item
          name="designation"
          label="Designation"
          rules={[{ required: true, message: "Designation is required" }]}
        >
          <Input placeholder="e.g. HR Manager, CTO" />
        </Form.Item>

        <Form.Item
          name="linkedinUrl"
          label="LinkedIn URL"
          rules={[
            {
              type: "url",
              message: "Enter a valid LinkedIn URL",
            },
          ]}
        >
          <Input placeholder="https://www.linkedin.com/in/username" />
        </Form.Item>
        <Form.Item name="region" label="Region" rules={[{ required: true }]}>
          <Select
            options={[
              { value: "India", label: "INDIA" },
              { value: "United States", label: "US" },
              { value: "United Kingdom", label: "UK" },
            ]}
          />
        </Form.Item>

        <Button type="primary" htmlType="submit" block>
          {isEdit ? "Update SPOC" : "Create SPOC"}
        </Button>
      </Form>
    </Modal>
  );
}
